import { $, type Html, html, View } from 'rune-ts';
import { RequiredValueEmptyError } from '../../../error';
import klass from './Radio.module.scss';
import type { Typo } from '../Typo/Typo';

export interface RadioData {
  name: string;
  value: string;
  label?: Typo | Html;
  disabled?: boolean;
  active?: boolean;
}

export class Radio extends View<RadioData> {
  input_element?: HTMLInputElement;

  override template() {
    const { name, disabled, active, label, value } = this.data;

    if (!name || !value) {
      throw new RequiredValueEmptyError(this, `data.name, data.value`);
    }

    return html`<label class="${klass.button_radio}">
      <input
        class="${klass.radio}"
        ${disabled ? 'disabled' : ''}
        ${active ? 'checked' : ''}
        type="radio"
        name="${name}"
        value="${value}"
      />
      <span class="${klass.radio_wrapper}">
        <span class="${klass.button}"></span>
        ${label}
      </span>
    </label>`;
  }

  protected override onRender() {
    this.input_element = $(this.element()).find('input[type="radio"]')?.element() as HTMLInputElement;
  }

  isChecked() {
    return !!this.input_element?.checked;
  }

  getValue() {
    return this.data.value;
  }
}
